export default {
    baseStyle: {
        container: {
            backgroundColor: 'gray.100',
            padding: '0 20px',
            textAlign: 'center'
        },
        footerContent: {
            sx: {
                span: {
                    color: 'black.100',
                    fontWeight: '400',
                    fontSize: '20px',
                    fontFamily: 'heading'
                },
                '.shipping-returns': {
                    display: 'inline-flex',
                    gap: '25px',
                    margin: 'auto',
                    alignItems: 'center'
                },
                ul: {
                    gap: '15px'
                },
                a: {
                    whiteSpace: 'nowrap'
                },
                '.checkout-footer': {
                    gap: '40px',
                    margin: '40px 0px 20px 0px',
                    display: 'grid'
                }
            }
        }
    }
}
